document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  const header = document.querySelector('[data-site-header]');
  const main = document.querySelector('#content');
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  if (header) {
    const updateHeaderSize = () => {
      header.classList.toggle('smaller', window.scrollY > 44);
    };

    updateHeaderSize();
    window.addEventListener('scroll', updateHeaderSize, { passive: true });
  }

  if (!toggle || !nav) {
    return;
  }

  const focusFirstNavItem = () => {
    const firstItem = nav.querySelector(focusableSelector);

    if (firstItem) {
      firstItem.focus();
    }
  };

  const setNavOpen = (shouldOpen, focusMenu = false) => {
    toggle.setAttribute('aria-expanded', String(shouldOpen));
    nav.classList.toggle('is-open', shouldOpen);
    document.body.classList.toggle('nav-is-open', shouldOpen);

    if (main) {
      main.toggleAttribute('inert', shouldOpen);
    }

    if (shouldOpen && focusMenu) {
      focusFirstNavItem();
    }
  };

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    setNavOpen(!isOpen, !isOpen);
  });

  nav.addEventListener('click', (event) => {
    const clickedLink = event.target.closest('a');
    const clickedFeedback = event.target.closest('[data-feedback-trigger]');

    if (clickedLink || clickedFeedback) {
      setNavOpen(false);

      if (!clickedFeedback) {
        toggle.focus();
      }
    }
  });

  document.addEventListener('click', (event) => {
    if (toggle.getAttribute('aria-expanded') !== 'true') {
      return;
    }

    if (nav.contains(event.target) || toggle.contains(event.target)) {
      return;
    }

    setNavOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || toggle.getAttribute('aria-expanded') !== 'true') {
      return;
    }

    setNavOpen(false);
    toggle.focus();
  });
});
